import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['readMore', 'oldText', 'newText'];

	readMore() {
		this.oldTextTarget.classList.add('hidden');
		this.readMoreTarget.classList.add('hidden');
		this.newTextTarget.classList.remove('hidden');
	}
}
